import { z } from 'zod';
import { CognitoSubSchema, CursorSchema, PaginationLimitSchema, TimestampSchema, paginatedSchema, } from '../common.js';
import { AuditLogEventSchema } from '../entities/auditLogEvent.js';
// =========================================================
// /v1/admin/audit-log — see docs/api.md §3.9
// =========================================================
const NINETY_DAYS_MS = 90 * 24 * 60 * 60 * 1000;
// GET /v1/admin/audit-log
export const AdminAuditLogQuerySchema = z
    .object({
    /** Inclusive lower bound. Default: 30 days ago, applied server-side. */
    from: TimestampSchema.optional(),
    /** Inclusive upper bound. Default: now, applied server-side. */
    to: TimestampSchema.optional(),
    tenantId: z.string().uuid().optional(),
    actorUserId: CognitoSubSchema.optional(),
    /** Glob, e.g. "tenant.*", "user.delete". */
    action: z.string().optional(),
    limit: PaginationLimitSchema.optional(),
    cursor: CursorSchema.optional(),
})
    .refine((v) => {
    if (!v.from || !v.to)
        return true;
    const span = new Date(v.to).getTime() - new Date(v.from).getTime();
    return span >= 0 && span <= NINETY_DAYS_MS;
}, { message: 'from/to span must be 0..90 days, with `to` ≥ `from`.' });
export const AdminAuditLogResponseSchema = paginatedSchema(AuditLogEventSchema);
//# sourceMappingURL=auditLog.js.map